import { render } from "./app-menu-primary.vue?vue&type=template&id=7207c20c&scoped=true"
import script from "./app-menu-primary.vue?vue&type=script&lang=js"
export * from "./app-menu-primary.vue?vue&type=script&lang=js"

import "./app-menu-primary.vue?vue&type=style&index=0&id=7207c20c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7207c20c"]])

export default __exports__